import { Injectable } from '@angular/core';
import { AppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import { resetNewPetState, setNewPetStep, startNewPet } from './actions/new-pet-steps.actions';
import { PetOwner } from '@app/core/models';
import { NewPetStep } from '../new-pet-step';
import { createNewPet, setNewPetOwnerValues } from './actions/new-pet.actions';
import { PetOwnerFormValues } from '@app/shared/components/pet-owner-form/pet-owner-form';
import { selectNewPetStep, selectNewPetSteps } from './selectors/new-pet-steps.selectors';
import { Observable } from 'rxjs';

@Injectable()
export class NewPetFacade {
  public step$: Observable<NewPetStep> = this.store$.pipe(select(selectNewPetStep));
  public steps$: Observable<NewPetStep[]> = this.store$.pipe(select(selectNewPetSteps));

  constructor(private readonly store$: Store<AppState>) {}

  /** new-pet-steps.actions */
  startNewPet(owner?: PetOwner): void {
    this.store$.dispatch(startNewPet({ owner }));
  }

  setNewPetStep(step: NewPetStep): void {
    this.store$.dispatch(setNewPetStep({ value: step }));
  }

  resetNewPetState(): void {
    this.store$.dispatch(resetNewPetState());
  }

  /** new-pet.actions */
  setNewPetOwnerValues(value: PetOwnerFormValues): void {
    this.store$.dispatch(setNewPetOwnerValues({ value }));
  }

  createNewPet(): void {
    this.store$.dispatch(createNewPet());
  }
}
